<template>
  <div style="position:relative;width: 1440px;height: 950px;margin: 0 auto">

    <h1 style="text-align: center;">Welcome to PGMG Server!</h1>
<!--    <h1 style="text-align: center;">In the future, we will update the results of the experiment verification on this page!</h1>-->

        <div class="content" style="
        float: left;
        position:absolute;
        width: 700px;
        height: 200px;
        left: 77px;
        background-color: white;
        opacity:0.8;
        z-index: 100;
        top:130px
        ">
          <div style="margin-top: 10px;margin-left: 10px;margin-right: 10px">
            <strong style="float: left;">What is PGMG Server</strong>
            <p style="float: left;margin-left: 2px">
              PGMG Server is a freely accessed webserver based on the pharmacophore-guided bioactive molecule generation
              method PGMG. PGMG Server provides fast drug-like molecule generation given the pharmacophore hypotheses for
              different drug design scenarios, such as ligand-based drug design, receptor-based drug design,
              scaffold-hopping, and so on.
            </p>
          </div>
        </div>

        <div style="text-align:center">
          <el-image src="https://www.csuligroup.com/DrugGen/img/pharmacophore_example.png"
                    style="position:absolute;width: 650px;height: 445px;
                            left: 690px;top:90px;opacity: 0.85" ></el-image>
        </div>

        <div style="position:absolute;float: left;top:384px;left: 77px;text-align: center">
          <el-image src="https://www.csuligroup.com/PGMG/img/f.png" style="
          width: 613px;height: 494px;">

          </el-image>
          <p>The overall architecture of PGMG.</p>
        </div>
        <div class="content" style="width: 628px;height: 359px;
        background-color: white;left: 730px;top: 520px;opacity: 0.8;
           position:absolute;">
          <div style="margin-top: 10px;margin-left: 10px;margin-right: 10px">
            <strong>What is PGMG</strong>
            <p>
              PGMG is a deep-learning based method aimed at providing a flexible strategy to generate bioactive molecules with structural diversity in various scenarios, especially when the activity data is scarce.
            </p>
            <p>
              PGMG only requires a pharmacophore hypothesis as input. The hypothesis can be constructed using only a few ligands or the structure of the receptor or the ligand-receptor complex. The pharmacophore hypothesis will be transformed into a weighted complete graph based on the shortest-path distance and feed into the model. The model will then rapidly generate a large number of molecules that satisfy the conditions.
            </p>
            <p>
              Details of PGMG can be found in arxiv.org/abs/2207.00821
            </p>
          </div>
        </div>


    <br>
  </div>

</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      link:"https://github.com/CSUBioGroup/PGMG"
    }
  },
  mounted() {
    // this.getImage()
    let options = {};
    let smilesDrawer = new SmilesDrawer.Drawer(options);
    console.log("111111111111111111111111")
    console.log(this.$route.params.SMILES)
    SmilesDrawer.parse("CN1C2CCC1C(=N)c1[nH]c3c(O)nc(C(=N)O)cc3c1C2", function(tree) {
      // Draw to the canvas
      smilesDrawer.draw(tree, "example-canvas", "light", false);
      // Alternatively, draw to SVG:
      // svgDrawer.draw(tree, 'output-svg', 'dark', false);
    });
  },
  methods:{
    getImage() {
      let input = document.getElementById("example-input");
      let options = {};

      // Initialize the drawer to draw to canvas
      let smilesDrawer = new SmilesDrawer.Drawer(options);
      // Alternatively, initialize the SVG drawer:
      // let svgDrawer = new SmilesDrawer.SvgDrawer(options);

      input.addEventListener("input", function () {
        // Clean the input (remove unrecognized characters, such as spaces and tabs) and parse it
        SmilesDrawer.parse(input.value, function (tree) {
          // Draw to the canvas
          smilesDrawer.draw(tree, "example-canvas", "light", false);
          // Alternatively, draw to SVG:
          // svgDrawer.draw(tree, 'output-svg', 'dark', false);
        });
      });
    }
  },

}
</script>

<style scoped>
  p{
    /*line-height: 1.5em;*/
    font-family: "Noto Sans SC";
    /*font-weight: 500;*/
  }
  h1,h2{
    font-family: "Noto Sans SC";
  }
div {
  /*min-height: 100%;*/
  /*text-align: left;*/
  /*max-width: 1140px;*/
  /*margin: 0 auto;*/
}
  .content{
    /*box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;*/
    /*background-color: RGB(255,255,255);*/
    /*border-radius: 10px;*/
    /*padding: 10px;*/
  }
</style>
